import styled from 'styled-components';
import { body2 } from 'ui/theme';

export const TextWrapper = styled.span`
  ${body2}
`;
